<template>
	<modal :modal-id="modalId" :title="modalTitle" :preloader="preloader" modal-alignment="center" @submit="submit"
		@close-modal="closeModal" :modal-scroll="false">
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form class="mb-0" :class="{ 'loading-opacity': preloader }" method="patch" ref="form">
				<!-- To Student -->
				<div v-if="params.includes('lead_to')" class="form-group d-flex flex-column justify-content-center">
					<label for="inputs_form_voucher_lead_to" class="mb-4">
						{{ $t("form_voucher_lead_to") }}
					</label>
					<app-input id="inputs_form_voucher_lead_to" class="" type="advance-search-select"
						:loaded-per-time="20" v-model="input_voucher_lead_to" @input="setToLeadValue"
						fetch-url="api/leads" :placeholder="$t('form_voucher_lead_to')" list-value-field="full_name"
						aria-autocomplete="none" :required="params.includes('lead_to')" />
				</div>
				<!-- To Student -->

				<!-- Recommended By -->
				<!-- <div v-if="params.includes('lead_by')" class="form-group d-flex flex-column justify-content-center">
					<label for="inputs_form_voucher_lead_by" class="mb-4">
						{{ $t("form_voucher_lead_by") }}
					</label>
					<app-input id="inputs_form_voucher_lead_by" class="" type="advance-search-select"
						:loaded-per-time="20" v-model="input_voucher_lead_by" @input="setByLeadValue"
						fetch-url="api/voucher/students" :placeholder="$t('form_voucher_lead_by')"
						list-value-field="name" aria-autocomplete="none" :required="params.includes('lead_by')" />
				</div> -->
				<!-- Recommended By -->
			</form>
		</template>
	</modal>
</template>

<script>
import { isArray } from "lodash";
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin.js";

export default {
	name: "ModalFormEditVoucher",
	mixins: [FormMixin, ModalMixin],
	props: {
		// tableId: String,
		modalTitle: String,
		formId: String,
		dataParams: {
			type: Array | 'lead_to',
			default: [],
		},
		value: {
			type: Object,
			default: () => {
				return {
					id: null,
					lead_to_id: {
						id: undefined,
						name: '',
					},
					// lead_by_id: {
					// 	id: undefined,
					// 	name: '',
					// },
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			params: typeof this.dataParams == 'string' ? [this.dataParams] : this.dataParams,
			input_voucher_lead_to: this.value
				? this.value.lead_to
					? {
						id:
							this.value.lead_to.id || 0,
						name:
							this.value.lead_to.name || "",
					}
					: {
						id:
							this.value.lead_to?.id || 0,
						name:
							this.value.lead_to?.name || "",
					}
				: {
					id: this.value.lead_to.id || 0,
					name:
						this.value.lead_to.name || "",
				},
			// input_voucher_lead_by: this.value
			// 	? this.value.lead_by
			// 		? {
			// 			id:
			// 				this.value.lead_by.id || 0,
			// 			name:
			// 				this.value.lead_by.name || "",
			// 		}
			// 		: {
			// 			id:
			// 				this.value.lead_by?.id || 0,
			// 			name:
			// 				this.value.lead_by?.name || "",
			// 		}
			// 	: {
			// 		id: this.value.lead_by.id || 0,
			// 		name:
			// 			this.value.lead_by.name || "",
			// 	},
			inputs: {
				name: "",
			},
			modalId: this.formId,
		};
	},
	methods: {
		submit() {
			if (!isArray(this.inputs.id)) this.inputs.id = [this.inputs.id];
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			// this.$hub.$emit("reload-" + this.tableId);
		},
		setToLeadValue(data) {
			this.inputs.lead_to_id = this.inputs.lead_to_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.lead_to_id = data.id;
				// this.input_voucher_lead_to = '';
			}
		},
		// setByLeadValue(data) {
		// 	this.inputs.lead_by_id = this.inputs.lead_by_id;
		// 	if (data && data.hasOwnProperty("id")) {
		// 		this.inputs.lead_by_id = data.id;
		// 		// this.input_voucher_lead_to = '';
		// 	}
		// },
	},
}
</script>
